const LEGACY_REVIEW_CONTENT_VERSION = 1;

export function currentContentVersion(role) {
  const version = Number(role?.contentVersion || role?.content?.version || 1);
  return Number.isInteger(version) && version > 0 ? version : 1;
}

export function reviewedContentVersion(review) {
  const version = Number(review?.contentVersion ?? LEGACY_REVIEW_CONTENT_VERSION);
  return Number.isInteger(version) && version > 0 ? version : LEGACY_REVIEW_CONTENT_VERSION;
}

export function isReviewCurrent(role, review) {
  if (!review || !review.status || review.status === 'not_reviewed') return true;
  return reviewedContentVersion(review) === currentContentVersion(role);
}

export function effectiveReviewStatus(role, review) {
  if (!review) return role?.patientStatus === 'published' ? 'published' : 'not_reviewed';
  if (!isReviewCurrent(role, review)) return 'updated_review_required';
  return review.status || (role?.patientStatus === 'published' ? 'published' : 'not_reviewed');
}

export function reviewDraftForRole(role, review = {}) {
  const contentVersion = currentContentVersion(role);
  if (isReviewCurrent(role, review)) {
    return { ...review, contentVersion, status: review.status || 'not_reviewed', saved: false };
  }
  return {
    ...review,
    status: 'not_reviewed',
    contentVersion,
    previousStatus: review.status || null,
    previousContentVersion: reviewedContentVersion(review),
    saved: false,
  };
}
